// Hurtigvalg-hentesteder for masse og løsmasse i Oslo/Akershus
// Oppdater koordinater og adresser ved behov — brukes i CreateOrder step 1. kind: 'supplier' (utsalg) eller 'receiver' (mottak).
// Admin-administrert versjon kan hentes fra Firestore /settings/quickPickups

export const QUICK_PICKUPS = [
  {
    id: 'franzefoss_ralingen',
    kind: 'supplier',
    name: 'Franzefoss Minerals',
    subtitle: 'Pukk, grus, sand',
    icon: '⛏️',
    street: 'Taraldrudveien 35, 2007 Kjeller',
    city: 'Kjeller',
    lat: 59.9241,
    lng: 11.0718,
  },
  {
    id: 'velde_vinterbro',
    kind: 'supplier',
    name: 'Velde Pukk Vinterbro',
    subtitle: 'Pukk, knust stein',
    icon: '🪨',
    street: 'Mosseveien 345, 1454 Fagerstrand',
    city: 'Fagerstrand',
    lat: 59.7425,
    lng: 10.7431,
  },
  {
    id: 'alnabru_massedeponi',
    kind: 'receiver',
    name: 'Alnabru Massemottak',
    subtitle: 'Jord, leire, fyllmasse',
    icon: '🏗️',
    street: 'Alnabruveien 100, 0668 Oslo',
    city: 'Oslo',
    lat: 59.9243,
    lng: 10.8622,
  },
  {
    id: 'furuset_gjenbruk',
    kind: 'receiver',
    name: 'Furuset Gjenbruksstasjon',
    subtitle: 'Jord, masse, inerte masser',
    icon: '♻️',
    street: 'Østre Aker vei 200, 0975 Oslo',
    city: 'Oslo',
    lat: 59.9353,
    lng: 10.8817,
  },
  {
    id: 'lysaker_steinknusing',
    kind: 'supplier',
    name: 'Bærum Pukkverk',
    subtitle: 'Pukk, grus, sand',
    icon: '⛏️',
    street: 'Vollsveien 2A, 1366 Lysaker',
    city: 'Lysaker',
    lat: 59.9063,
    lng: 10.6272,
  },
  {
    id: 'asland_massedeponi',
    kind: 'receiver',
    name: 'Åsland Massedeponi',
    subtitle: 'Tunnelmasse, jord',
    icon: '🏔️',
    street: 'Åslandsveien 100, 1275 Oslo',
    city: 'Oslo',
    lat: 59.8589,
    lng: 10.8421,
  },
];
